(function () {
  const STORAGE_KEY = 'il_ilce_selection';
  let ilIlceData = null;
  let saveInFlight = null;

  // İl adı -> plaka kodu (ISO 3166-2:TR alt bölüm numarası)
  const IL_PLAKA_KODU = {
    "Adana": "01", "Adıyaman": "02", "Afyonkarahisar": "03", "Ağrı": "04", "Amasya": "05",
    "Ankara": "06", "Antalya": "07", "Artvin": "08", "Aydın": "09", "Balıkesir": "10",
    "Bilecik": "11", "Bingöl": "12", "Bitlis": "13", "Bolu": "14", "Burdur": "15",
    "Bursa": "16", "Çanakkale": "17", "Çankırı": "18", "Çorum": "19", "Denizli": "20",
    "Diyarbakır": "21", "Edirne": "22", "Elazığ": "23", "Erzincan": "24", "Erzurum": "25",
    "Eskişehir": "26", "Gaziantep": "27", "Giresun": "28", "Gümüşhane": "29", "Hakkari": "30",
    "Hatay": "31", "Isparta": "32", "Mersin": "33", "İstanbul": "34", "İzmir": "35",
    "Kars": "36", "Kastamonu": "37", "Kayseri": "38", "Kırklareli": "39", "Kırşehir": "40",
    "Kocaeli": "41", "Konya": "42", "Kütahya": "43", "Malatya": "44", "Manisa": "45",
    "Kahramanmaraş": "46", "Mardin": "47", "Muğla": "48", "Muş": "49", "Nevşehir": "50",
    "Niğde": "51", "Ordu": "52", "Rize": "53", "Sakarya": "54", "Samsun": "55",
    "Siirt": "56", "Sinop": "57", "Sivas": "58", "Tekirdağ": "59", "Tokat": "60",
    "Trabzon": "61", "Tunceli": "62", "Şanlıurfa": "63", "Uşak": "64", "Van": "65",
    "Yozgat": "66", "Zonguldak": "67", "Aksaray": "68", "Bayburt": "69", "Karaman": "70",
    "Kırıkkale": "71", "Batman": "72", "Şırnak": "73", "Bartın": "74", "Ardahan": "75",
    "Iğdır": "76", "Yalova": "77", "Karabük": "78", "Kilis": "79", "Osmaniye": "80",
    "Düzce": "81"
  };

  async function loadData() {
    if (ilIlceData) return ilIlceData;
    const res = await fetch(window.ilIlceJsonUrl);
    ilIlceData = await res.json();
    return ilIlceData;
  }

  async function getFullCartId() {
    // Ajax Cart API'nin token alanı 2024-06-21'den itibaren key parametresini de içeriyor,
    // bu yüzden cookie'den okumak yerine doğrudan /cart.js'ten alıyoruz.
    const res = await fetch('/cart.js');
    const cart = await res.json();
    if (!cart || !cart.token) return null;
    // cart.token zaten "<id>?key=<secret>" formatında geliyor
    return `gid://shopify/Cart/${cart.token}`;
  }

  async function storefrontRequest(query, variables) {
    const res = await fetch(`/api/${window.STOREFRONT_API_VERSION}/graphql.json`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': window.STOREFRONT_TOKEN
      },
      body: JSON.stringify({ query, variables })
    });
    return res.json();
  }

  async function saveIlIlce(il, ilce) {
    try {
      const fullCartId = await getFullCartId();
      if (!fullCartId) {
        console.warn('İl/İlçe kaydetme hatası: cart token alınamadı');
        return;
      }

      const metafieldsQuery = `
        mutation setIlIlce($metafields: [CartMetafieldsSetInput!]!) {
          cartMetafieldsSet(metafields: $metafields) {
            metafields { key value }
            userErrors { message }
          }
        }`;

      const ADDRESS_ID_KEY = 'il_ilce_address_id';
      const existingAddressId = sessionStorage.getItem(ADDRESS_ID_KEY);

      const addAddressQuery = `
        mutation addAddress($cartId: ID!, $addresses: [CartSelectableAddressInput!]!) {
          cartDeliveryAddressesAdd(cartId: $cartId, addresses: $addresses) {
            cart {
              id
              delivery {
                addresses { id selected }
              }
            }
            userErrors { message }
          }
        }`;

      const updateAddressQuery = `
        mutation updateAddress($cartId: ID!, $addresses: [CartSelectableAddressUpdateInput!]!) {
          cartDeliveryAddressesUpdate(cartId: $cartId, addresses: $addresses) {
            cart {
              id
              delivery {
                addresses { id selected }
              }
            }
            userErrors { message }
          }
        }`;

      const metafieldsVars = {
        metafields: [
          { ownerId: fullCartId, key: 'custom.il', type: 'single_line_text_field', value: il },
          { ownerId: fullCartId, key: 'custom.ilce', type: 'single_line_text_field', value: ilce }
        ]
      };

      const deliveryAddress = { city: il, address2: ilce, countryCode: 'TR' };

      const buildAddVars = () => ({
        cartId: fullCartId,
        addresses: [{
          selected: true,
          oneTimeUse: true,
          address: { deliveryAddress }
        }]
      });

      let addressQuery, addressVars, usedUpdate;
      if (existingAddressId) {
        addressQuery = updateAddressQuery;
        usedUpdate = true;
        addressVars = {
          cartId: fullCartId,
          addresses: [{
            id: existingAddressId,
            address: { deliveryAddress },
            selected: true
          }]
        };
      } else {
        addressQuery = addAddressQuery;
        usedUpdate = false;
        addressVars = buildAddVars();
      }

      const [metaRes, addrResFirst] = await Promise.all([
        storefrontRequest(metafieldsQuery, metafieldsVars),
        storefrontRequest(addressQuery, addressVars)
      ]);

      let addrRes = addrResFirst;
      let firstAttemptFailed =
        (addrRes?.errors && addrRes.errors.length > 0) ||
        (addrRes?.data?.cartDeliveryAddressesUpdate?.userErrors?.length > 0);

      // Update başarısız olduysa (örn. eski/geçersiz address ID) yeni bir adres olarak ekle
      if (usedUpdate && firstAttemptFailed) {
        console.warn('Adres güncelleme başarısız (muhtemelen eski ID), yeni adres olarak ekleniyor.');
        sessionStorage.removeItem(ADDRESS_ID_KEY);
        addrRes = await storefrontRequest(addAddressQuery, buildAddVars());
      }

      const metaErrors = [
        ...(metaRes?.errors || []),
        ...(metaRes?.data?.cartMetafieldsSet?.userErrors || [])
      ];
      const addrErrors = [
        ...(addrRes?.errors || []),
        ...(addrRes?.data?.cartDeliveryAddressesAdd?.userErrors || []),
        ...(addrRes?.data?.cartDeliveryAddressesUpdate?.userErrors || [])
      ];

      // Metafield yazımı hatasız görünse bile sessizce tutmamış olabilir
      // (gördüğümüz gerçek bir vaka: eski değer siparişe kopyalandı).
      // Yazdıktan hemen sonra geri okuyup doğrula, tutmuyorsa bir kez daha dene.
      if (metaErrors.length === 0) {
        const verifyQuery = `
          query verifyCart($id: ID!) {
            cart(id: $id) {
              metafields(identifiers: [{namespace:"custom", key:"il"},{namespace:"custom", key:"ilce"}]) {
                key value
              }
            }
          }`;
        const verifyRes = await storefrontRequest(verifyQuery, { id: fullCartId });
        const fields = verifyRes?.data?.cart?.metafields || [];
        const gotIl = fields.find(f => f.key === 'il')?.value;
        const gotIlce = fields.find(f => f.key === 'ilce')?.value;

        if (gotIl !== il || gotIlce !== ilce) {
          console.warn('Metafield doğrulaması tutmadı, tekrar yazılıyor:', { beklenen: { il, ilce }, gelen: { gotIl, gotIlce } });
          const retryRes = await storefrontRequest(metafieldsQuery, metafieldsVars);
          const retryErrors = [
            ...(retryRes?.errors || []),
            ...(retryRes?.data?.cartMetafieldsSet?.userErrors || [])
          ];
          if (retryErrors.length) {
            console.warn('Metafield yeniden yazma da başarısız:', JSON.stringify(retryErrors, null, 2));
            metaErrors.push(...retryErrors);
          }
        }
      }

    // İlk ekleme başarılıysa, döndürülen adres ID'sini sonraki güncellemeler için sakla
    const wasAddCall = !usedUpdate || firstAttemptFailed;
    let currentAddressId = wasAddCall ? null : existingAddressId;
    if (wasAddCall && addrErrors.length === 0) {
      const addresses = addrRes?.data?.cartDeliveryAddressesAdd?.cart?.delivery?.addresses || [];
      const newAddress = addresses.find(a => a.selected) || addresses[addresses.length - 1];
      if (newAddress?.id) {
        currentAddressId = newAddress.id;
        sessionStorage.setItem(ADDRESS_ID_KEY, currentAddressId);
      }
    }

    if (metaErrors.length || addrErrors.length) {
      console.warn('İl/İlçe kaydetme hatası:', JSON.stringify({ metaErrors, addrErrors }, null, 2));
    }

      // Bizim adresimiz dışında kalan (eski/kullanılmayan) adresleri temizle
      if (currentAddressId) {
        const addresses =
          addrRes?.data?.cartDeliveryAddressesAdd?.cart?.delivery?.addresses ||
          addrRes?.data?.cartDeliveryAddressesUpdate?.cart?.delivery?.addresses || [];
        const staleIds = addresses.map(a => a.id).filter(id => id !== currentAddressId);

        if (staleIds.length > 0) {
          const removeQuery = `
            mutation removeAddresses($cartId: ID!, $addressIds: [ID!]!) {
              cartDeliveryAddressesRemove(cartId: $cartId, addressIds: $addressIds) {
                userErrors { message }
              }
            }`;
          storefrontRequest(removeQuery, { cartId: fullCartId, addressIds: staleIds })
            .then(res => {
              const removeErrors = res?.data?.cartDeliveryAddressesRemove?.userErrors || [];
              if (removeErrors.length) {
                console.warn('Eski adres temizleme hatası:', JSON.stringify(removeErrors, null, 2));
              }
            })
            .catch(err => console.warn('Eski adres temizleme isteği başarısız:', err));
        }
      }
    } catch (err) {
      console.warn('İl/İlçe kaydetme sırasında beklenmeyen hata (checkout engellenmedi):', err);
    }
  }

  function getCheckoutButton() {
    const drawer = document.getElementById('CartDrawer');
    return drawer ? drawer.querySelector('[name="checkout"]') : null;
  }

  function toggleCheckoutButton() {
    const btn = getCheckoutButton();
    if (!btn) return;

    const saved = sessionStorage.getItem(STORAGE_KEY);
    const hasSelection = !!saved;

    btn.disabled = !hasSelection;
    if (hasSelection) {
      btn.style.opacity = '';
      btn.style.pointerEvents = '';
      btn.style.cursor = '';
      hideError();
    } else {
      btn.style.opacity = '0.4';
      btn.style.pointerEvents = 'none';
      btn.style.cursor = 'not-allowed';
      showError();
    }
  }

  function bind() {
    const ilSelect = document.querySelector('[id^="IlSelect-"]');
    const ilceSelect = document.querySelector('[id^="IlceSelect-"]');
    if (!ilSelect || !ilceSelect) return null;

    loadData().then(data => {
      if (ilSelect.dataset.bound) return;
      ilSelect.dataset.bound = 'true';

      Object.keys(data).sort().forEach(il => {
        const opt = document.createElement('option');
        opt.value = il;
        opt.textContent = il;
        ilSelect.appendChild(opt);
      });

      ilSelect.addEventListener('change', () => onIlChange(data, ilSelect, ilceSelect));
      ilceSelect.addEventListener('change', () => onComplete(ilSelect, ilceSelect));

      restore(data, ilSelect, ilceSelect);
    });

    toggleCheckoutButton();

    return { ilSelect, ilceSelect };
  }

  function onIlChange(data, ilSelect, ilceSelect, preselect) {
    const il = ilSelect.value;
    ilceSelect.innerHTML = '<option value="">İlçe seçiniz</option>';
    if (!il) {
      ilceSelect.disabled = true;
      sessionStorage.removeItem(STORAGE_KEY);
      toggleCheckoutButton();
      return;
    }

    data[il].forEach(ilce => {
      const opt = document.createElement('option');
      opt.value = ilce;
      opt.textContent = ilce;
      if (ilce === preselect) opt.selected = true;
      ilceSelect.appendChild(opt);
    });
    ilceSelect.disabled = false;
  }

  function onComplete(ilSelect, ilceSelect) {
    const il = ilSelect.value;
    const ilce = ilceSelect.value;

    if (!il || !ilce) {
      sessionStorage.removeItem(STORAGE_KEY);
      toggleCheckoutButton();
      return;
    }

    sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ il, ilce }));
    saveInFlight = saveIlIlce(il, ilce);
    hideError();
    toggleCheckoutButton();
  }

  function restore(data, ilSelect, ilceSelect) {
    const saved = sessionStorage.getItem(STORAGE_KEY);
    if (!saved) return;
    const { il, ilce } = JSON.parse(saved);
    if (!data[il]) return;

    ilSelect.value = il;
    onIlChange(data, ilSelect, ilceSelect, ilce);
  }

  function showError() {
    document.querySelector('.il-ilce-error')?.removeAttribute('hidden');
  }
  function hideError() {
    document.querySelector('.il-ilce-error')?.setAttribute('hidden', '');
  }

  function bindCheckoutGuard() {
    const drawer = document.getElementById('CartDrawer');
    if (!drawer) return;

    let bypassGuard = false;

    drawer.addEventListener('submit', async (e) => {
      const submitter = e.submitter;
      if (!submitter || submitter.name !== 'checkout') return;

      if (bypassGuard) {
        bypassGuard = false;
        return; // requestSubmit ile tetiklenen ikinci event, normal submit'e izin ver
      }

      const saved = sessionStorage.getItem(STORAGE_KEY);
      if (!saved) {
        e.preventDefault();
        showError();
        return;
      }

      if (saveInFlight) {
        e.preventDefault();
        try {
          let timedOut = false;
          const timeout = new Promise(resolve => setTimeout(() => { timedOut = true; resolve(); }, 10000));
          await Promise.race([saveInFlight, timeout]);
          if (timedOut) {
            console.warn('İl/İlçe kaydı 10 saniyede tamamlanmadı, checkout yine de devam ediyor.');
          }
        } catch (err) {
          console.warn('İl/İlçe kaydı sırasında hata oluştu, checkout yine de devam ediyor:', err);
        } finally {
          bypassGuard = true;
          try {
            // await sırasında drawer yeniden render edilmiş olabilir; e.target ve
            // submitter artık DOM'da olmayabilir. Canlı DOM'dan taze referans al.
            const freshBtn = getCheckoutButton();
            const freshForm = freshBtn ? freshBtn.closest('form') : null;

            if (freshForm && freshBtn) {
              freshForm.requestSubmit(freshBtn);
            } else if (submitter.isConnected && e.target.contains(submitter)) {
              e.target.requestSubmit(submitter);
            } else {
              e.target.submit();
            }
          } catch (submitErr) {
            console.warn('requestSubmit başarısız, native submit deneniyor:', submitErr);
            try {
              const fallbackForm = getCheckoutButton()?.closest('form') || e.target;
              fallbackForm.submit();
            } catch (finalErr) {
              console.warn('Checkout submit tamamen başarısız oldu:', finalErr);
            }
          }
        }
      }
    });
  }

  function init() {
    bind();
    bindCheckoutGuard();
  }

  document.addEventListener('DOMContentLoaded', init);

  const observer = new MutationObserver(() => {
    if (document.querySelector('[id^="IlSelect-"]')) bind();
  });
  document.addEventListener('DOMContentLoaded', () => {
    const drawer = document.getElementById('CartDrawer');
    if (drawer) observer.observe(drawer, { childList: true, subtree: true });
  });
})();